import React, { useState, useEffect } from "react";
import {
  CREATE_PUBLIC_WORKFLOW_CATEGORIES,
  DELETE_PUBLIC_WORKFLOW_CATEGORY,
  UPDATE_PUBLIC_WORKFLOW_CATEGORY,
} from "../../graphql/mutations";
import { GET_PUBLIC_WORKFLOW_CATEGORIES } from "../../graphql/queries";
import PublicWorkflowCategories from "./index";
import { useQuery, useMutation } from "@apollo/react-hooks";

const PublicWorkflowCategoriesQueries = () => {
  const [categoryList, setCategoryList] = useState<any>([]);
  const [pageNumberState, setPageNumberState] = useState(1);
  const handlePageNumberChange = (pageNumber: number) => setPageNumberState(pageNumber);
  const [searchEmail, setsearchEmail] = useState<string>('')


  const { data, loading, refetch } = useQuery(GET_PUBLIC_WORKFLOW_CATEGORIES, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    refetch()
  }, [pageNumberState])

  useEffect(() => {
    setCategoryList(data)
  }, [data])

  useEffect(() => {
    refetchData()
  }, [searchEmail])

  const refetchData = async () => {
    await refetch()
  }

  const [deleteCategory] = useMutation(DELETE_PUBLIC_WORKFLOW_CATEGORY)

  const [updateCategory] = useMutation(UPDATE_PUBLIC_WORKFLOW_CATEGORY)



  const [createCategory] = useMutation(CREATE_PUBLIC_WORKFLOW_CATEGORIES, {
    onCompleted: () => {
      refetchData();
    }
  })

  return (
    <PublicWorkflowCategories
      data={categoryList}
      loading={loading}
      searchEmail={searchEmail}
      setsearchEmail={setsearchEmail}
      onPageNumberChange={handlePageNumberChange}
      createAutomationCategory={createCategory}
      deleteCategory={deleteCategory}
      updateCategory={updateCategory}
    />
  )
};


export default PublicWorkflowCategoriesQueries;
